import { View } from './view';

export class StripeBacsView extends View {

    stripeFormContainer = document.createElement('div');

    renderStripeFormFragment() {
        const srtipeFormFragment = document.createDocumentFragment();
        this.stripeFormContainer.setAttribute('id', 'stripe-bacs-form-block');
        const fieldsElements = this.getBacsDebitField();
        this.stripeFormContainer.innerHTML = `${fieldsElements}`;
        srtipeFormFragment.appendChild(this.stripeFormContainer);
        const container = this.getDFContainer();
        container.appendChild(srtipeFormFragment);
    }

    getBacsDebitField() {
        return `
            <form class='hs-form stacked df-f df-f-stripe' id='df_stripe_bacs_form' action='javascript:void(0);' method='POST'>
                <div id="df_stripe_bacs_elements_container">
                    <fieldset class='form-columns-1 df-payment-field df-fieldset'>
                        <div class='field hs-form-field df-field'>
                            <div id='stripe_bacs_elements' class='stripe_bacs_elements'></div>
                        </div>
                        <fieldset class='form-columns-1 df-fieldset'><label class='error' id='stripe_bacs_error'></label></fieldset>
                    </fieldset>
                </div>
            </form>`;
    }

    showStripeElementsContainer() {
        const stripeBacsFormContainer = document.querySelector('#df_stripe_bacs_elements_container') as any;
        if (stripeBacsFormContainer) {
            stripeBacsFormContainer.style.display = 'block';
        }
    }

    hideStripeElementsContainer() {
        const stripeBacsFormContainer = document.querySelector('#df_stripe_bacs_elements_container') as any;
        if (stripeBacsFormContainer) {
            stripeBacsFormContainer.style.display = 'none';
        }
    }

    showStripeBacsFormBlock() {
        const stripeBacsFormBlock = document.querySelector('#stripe-bacs-form-block') as any;
        if (stripeBacsFormBlock) {
            stripeBacsFormBlock.style.display = 'block';
        }
    }

    removeDefaultBacsElementsStyle() {
        const stripeBacsElement = document.querySelector('#stripe_bacs_elements') as any;
        if (stripeBacsElement) {
            stripeBacsElement.style = {};
        }
    }

    hidePayNowButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'none';
        }
    }

    showPayNowButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'inline-block';
            button.setAttribute('data-label', 'pay_now');
        }
    }

    setVisible(isActive: boolean) {
        const form = this.getHtmlElement('#stripe-bacs-form-block');
        if (!form) {
            return;
        }
        if (isActive) {
            this.show(form);
            this.showPayNowButton();
        } else {
            this.hide(form);
            this.hidePayNowButton();
        }
    }

    applyHubspotCss() {
        const hsInput = this.getFromHSFrame('input.hs-input[name=email]');

        const ignoreElements = ['width', 'inline-size', 'display', 'margin-right', 'margin-inline', 'margin-inline-end', 'margin-inline-start'];

        if (hsInput) {
            //const computedStyles = window.getComputedStyle(hsInput, '').cssText;

            const style = window.getComputedStyle(hsInput, '');

            let computedStyles = '';

            for (let i = 0; i < style.length; i++) {
                if (ignoreElements.indexOf(style[i]) < 0) {
                    computedStyles += style[i] + ': ' + style.getPropertyValue(style[i]) + '; ';
                }
            }

            const stripeContainers = this.getHtmlElements('.stripe_bacs_elements');
            stripeContainers.forEach(stripeContainer => {

                //stripeContainer.style.cssText = this.stripCss(computedStyles);
                stripeContainer.setAttribute('style', computedStyles);

                // Calc proper padding
                const height = hsInput.offsetHeight;
                if (height) {
                    const adjHeight = (height - 18) / 2;
                    stripeContainer.style.paddingLeft = adjHeight + 'px';
                    stripeContainer.style.paddingRight = adjHeight + 'px';
                    stripeContainer.style.paddingTop = adjHeight + 'px';
                }
            }, 'nodes');
        }
    }

    hideStripeBacsForm() {
        const stripeBacsForm: any = document.querySelector('#stripe-bacs-form-block');
        if (stripeBacsForm) {
            stripeBacsForm.style.display = 'none';
        }
    }

    showStripeBacsForm() {
        const stripeBacsForm: any = document.querySelector('#stripe-bacs-form-block');
        if (stripeBacsForm) {
            stripeBacsForm.style.display = 'block';
        }
    }

    getTotal(): number {
        const totalChar = document.getElementById('df-final-amount');
        if (totalChar) {
            return parseInt(totalChar.innerText.replace(/^\D+/g, ''), 10) || 0;
        }
        return 0;
    }

    showForm() {
        this.stripeFormContainer.style.display = 'initial';
    }

    hideForm() {
        this.stripeFormContainer.style.display = 'none';
    }

}
